import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Preloader from '../components/Preloader';
import { API_ENDPOINTS } from '../config/api';

import axios from 'axios';
const url = API_ENDPOINTS.INSURANCE_PROVIDERS;

const InsuranceProviders = (props) => {
  const { cached, updateCache } = props;
  const [tableMessage, setTableMessage] = useState('Loading data...');
  const [formData, setFormData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [insuranceProviders, setInsuranceProviders] = useState(cached.insuranceProviders);
  const [updated, setUpdated] = useState({
    insuranceProviders: false,
  });

  useEffect(() => {
    if ( cached.insuranceProviders ) {
      setInsuranceProviders(cached.insuranceProviders.sort((a, b) => (a.name > b.name) ? 1 : -1));
    } else if (!updated.insuranceProviders) {
      setUpdated({...updated, insuranceProviders: true});
      makeRequest('GET');
    }
  }, [JSON.stringify(cached?.insuranceProviders)]);

  const onChangeHandler = (e) => {
    const { name, value, type, checked } = e.currentTarget;
    const val = type === 'checkbox' ? checked : type === 'select' ? e.target.value : value;

    setFormData({
      ...formData,
      [name]: val,
    });
  }

  const onSubmitHandler = () => {
    if ( formData.id >= 0 ) {
      makeRequest('PUT');
    } else {
      makeRequest('POST');
    }
  }

  const clearFormHandler = () => {
    setFormData({});
  }

  const onDeleteHandler = (id) => {
    if (window.confirm('Do you really want to delete it?')) {
      makeRequest('DELETE', id);
    }
  }

  const makeRequest = (method, id) => {
    setDisabled(true);

    let requestUrl = url;
    let message = method === 'POST' ? 'Item is added' : 
                  method === 'PUT' ? 'Item is updated' :
                  method === 'DELETE' ? 'Item is deleted' : null;

    const requestData = {
      method: method,
      signal: AbortSignal.timeout(20000)
    };

    if ( method === 'POST' || method === 'PUT' ) {
      requestData.data = { ...formData };
    }

    if ( method === 'DELETE' || method === 'PUT' ) {
      const requestId = id ? id : formData.id;

      requestUrl += `/${requestId}`;
    }

    axios(requestUrl, requestData).then((response) => {
      clearFormHandler();

      if ( method === 'GET' ) {
        updateCache(response.data);
        setDisabled(false);
      } else {
        makeRequest('GET');
      }

      if ( message ) {
        toast.success(message, {
          position: 'top-right'
        });
      }
    }).catch( (error) => {
      let err = 'Error: ';

      if (error.response) {
        err += error.response.data.errors;
      } else if (error.request) {
        err += 'No response!';
      } else {
        err += error.message;
      }

      setTableMessage(err);

      toast.error(err, {
        position: 'top-right'
      });
      
      setDisabled(false);
    });
  }

  const updating = typeof insuranceProviders === 'undefined' ? true : false;

  return (
      <div style={{minHeight: 200}} className="container-fluid position-relative">
        { updating ? <Preloader /> : (
          <React.Fragment>
            <h2 className="mt-5">Insurance Providers</h2>

            <div className="mt-5">
              <div className="form-group row">
                <div className="col-6 form-group">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    disabled={disabled || updating}
                    name="name"
                    onChange={(e) => onChangeHandler(e)}
                    value={formData.name || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Website URL</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={disabled || updating}
                    placeholder="Website URL"
                    name="website_url"
                    onChange={(e) => onChangeHandler(e)}
                    value={formData.website_url || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Alarmcentral Number</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={disabled || updating}
                    placeholder="Alarmcentral Number"
                    name="alarmcentral_number"
                    onChange={(e) => onChangeHandler(e)}
                    value={formData.alarmcentral_number || ''}
                  />
                </div>
                <div className="col-6 form-group">
                  <label className="form-label">Switchboard Number</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={disabled || updating}
                    placeholder="Switchboard Number"
                    name="switchboard_number"
                    onChange={(e) => onChangeHandler(e)}
                    value={formData.switchboard_number || ''}
                  />
                </div>
              </div>

              <button disabled={disabled || updating} className="btn btn-primary me-2" onClick={() => onSubmitHandler()}>{formData.id >= 0 ? 'Update' : 'Add'}</button>
              <button disabled={disabled || updating} className="btn btn-secondary" onClick={() => clearFormHandler()}>Clear</button>
          </div>               

            <table className="table table-hover mt-5">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col" style={{width: '100%'}}>Name</th>
                  <th style={{whiteSpace: 'nowrap'}} scope="col">Alarm Number</th>
                  <th style={{whiteSpace: 'nowrap'}} scope="col">Switchboard Number</th>
                  <th style={{whiteSpace: 'nowrap'}} scope="col">Website</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                { insuranceProviders ? insuranceProviders.map((item, index) => {
                  return (
                    <tr key={`country-${index}`}>
                      <th scope="row">{index+1}</th>
                      <td>{item.name ? item.name : '-'}</td>
                      <td style={{whiteSpace: 'nowrap'}}>{item.alarmcentral_number ? <a href={`tel:${item.alarmcentral_number}`}>{item.alarmcentral_number}</a> : '-'}</td>
                      <td style={{whiteSpace: 'nowrap'}}>{item.switchboard_number ? <a href={`tel:${item.switchboard_number}`}>{item.switchboard_number}</a> : '-'}</td>
                      <td>{item.website_url ? <i title={item.website_url}>YES</i> : '-'}</td>
                      <td style={{whiteSpace: 'nowrap'}}>
                        <button className="btn btn-danger me-1" onClick={() => onDeleteHandler(item.id)}>Delete</button>
                          <button className="btn btn-primary ms-1" onClick={() => {
                            setFormData({ ...item });
                            window.scrollTo(0, 0);
                          }}>Edit</button>
                      </td>
                  </tr>
                  );
                }) : <tr><td style={{textAlign: 'center', padding: 32}} colSpan="6">{tableMessage}</td></tr> }
              </tbody>
            </table>
          </React.Fragment>
        )}
      </div>
  );
}

export default InsuranceProviders;
